import React from "react";
import { motion } from "framer-motion";
import { Quote } from "lucide-react";

/**
 * Patron / community endorsement section, inspired by the way Karuna
 * features Dame Judi Dench. Quote + attribution + a soft serif feel.
 *
 * Copy is intentionally plural — once a Patron is appointed, replace the
 * `defaultQuote` block with their words and add their photo URL.
 */
export default function PatronQuote({
  quote = "Babasaheb did not merely give us a constitution. He gave us a way of seeing ourselves — as equals, as citizens, as Buddhists by choice. This network is the quiet inheritance of that gift.",
  attribution = "The Founding Trustees · Ambedkarite Buddhist Global Network UK",
  imageUrl,
}) {
  return (
    <section className="py-24 bg-pearl" data-testid="home-patron-quote">
      <div className="section-container max-w-5xl">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.7 }}
          className="relative bg-white border border-navy/10 rounded-sm p-10 sm:p-14"
        >
          <Quote size={48} className="text-saffron/40 absolute top-6 left-6" strokeWidth={1.2} />
          <div className="relative grid grid-cols-1 sm:grid-cols-[1fr_auto] gap-8 items-center">
            <div>
              <p className="font-display text-2xl sm:text-3xl text-navy leading-snug italic">
                "{quote}"
              </p>
              <p className="mt-6 text-sm uppercase tracking-widest text-slate-500">{attribution}</p>
            </div>
            {imageUrl && (
              <img
                src={imageUrl}
                alt={attribution}
                className="w-32 h-32 sm:w-44 sm:h-44 rounded-full object-cover border-4 border-saffron/30"
              />
            )}
          </div>
        </motion.div>
      </div>
    </section>
  );
}
